/**
 * Secure logging utility that prevents information leakage in production
 * Only logs in development environment to satisfy SAST requirements (CWE-497)
 */

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * Safe error logging - only logs in development
 */
export const logError = (message: string, error?: any): void => {
  if (isDevelopment) {
    console.error(message, error);
  }
  // In production: silent (prevents CWE-497 System Information Leak)
};

/**
 * Safe info logging - only logs in development
 */
export const logInfo = (message: string, data?: any): void => {
  if (isDevelopment) {
    console.log(message, data);
  }
};

/**
 * Safe warning logging - only logs in development
 */
export const logWarning = (message: string, data?: any): void => {
  if (isDevelopment) {
    console.warn(message, data);
  }
};

/**
 * Log only in development, completely silent in production
 */
export const logDebug = (...args: any[]): void => {
  if (isDevelopment) {
    console.log('[DEBUG]', ...args);
  }
};

export default {
  error: logError,
  info: logInfo,
  warning: logWarning,
  debug: logDebug,
};
